import { LUCKET_COLOR_RANK, STATUS_OPTION, TimeOptions } from "../../constants";
import { activeLuckets, activeLucketsWeek } from "./filterBuckets";

function convertToObject(buckets) {
  return {
    name: buckets[0],
    order: buckets[1],
    category: buckets[2],
    description: buckets[3],
    status: buckets[4],
    actionStatus: buckets[5],
    points: buckets[6]
  }
}


export function lifeStatusCalculator(buckets, currentDate) {

  let minimumColourNumber;
  let minimumColour;
  let activeBuckets = activeLuckets(buckets, currentDate);
  activeBuckets.forEach(element => {

    let colourNumber = LUCKET_COLOR_RANK[element.actionStatus]
    if (!minimumColourNumber) {
      minimumColourNumber = colourNumber
      minimumColour = element.actionStatus
    }
    else if (colourNumber < minimumColourNumber) {
      minimumColourNumber = colourNumber
      minimumColour = element.actionStatus
    }
  });

  return minimumColour
}
export function lifeWeekStatusCalculator(buckets, currentDate) {
  let minimumColourNumber;
  let minimumColour;
  let activeBuckets = activeLucketsWeek(buckets, currentDate);
  activeBuckets.forEach(element => {

    let colourNumber = LUCKET_COLOR_RANK[element.weekActionStatus]
    if (!minimumColourNumber) {
      minimumColourNumber = colourNumber
      minimumColour = element.weekActionStatus
    }
    else if (colourNumber < minimumColourNumber) {
      minimumColourNumber = colourNumber
      minimumColour = element.weekActionStatus
    }
  });

  return minimumColour
}
export function fontColourCalculator(color) {
  switch (color) {
    case STATUS_OPTION.Black:
      return "white"
    case STATUS_OPTION.Blue:
      return "white"
    case STATUS_OPTION.Green:
      return "white"
    case STATUS_OPTION.Purple:
      return "white"
    case STATUS_OPTION.Red:
      return "white"
    case STATUS_OPTION.White:
      return "black"
    case STATUS_OPTION.Yellow:
      return "black"
    default:
      break;
  }
}

export function calculateTimeSlot(time) {
  const hour = time.getHours();

  if (hour >= 0 && hour < 2) {
    return TimeOptions[0]; // Late Night
  } else if (hour >= 2 && hour < 6) {
    return TimeOptions[1]; // Dawn
  } else if (hour >= 6 && hour < 9) {
    return TimeOptions[2]; // Early Morning
  } else if (hour >= 9 && hour < 12) {
    return TimeOptions[3]; // Morning
  } else if (hour >= 12 && hour < 14) {
    return TimeOptions[4]; // Noon
  } else if (hour >= 14 && hour < 18) {
    return TimeOptions[5]; // Afternoon
  } else if (hour >= 18 && hour < 21) {
    return TimeOptions[6]; // Evening
  } else {
    return TimeOptions[7]; // Night
  }
}